import { Col, Offcanvas, Row} from "react-bootstrap";
import {Dispatch} from "react";
import { IoHomeOutline } from "react-icons/io5";
import { IoQrCodeOutline } from "react-icons/io5";
import { IoIosLink } from "react-icons/io";
import { IoPersonCircleSharp } from "react-icons/io5";
import { FaMoneyCheck } from "react-icons/fa";
import {useAuthData} from "../../../context/AuthContext";
import {Link} from "react-router-dom";
import {FiPower} from "react-icons/fi";

export type MobileOffCanvasProps = {
    showState:boolean
    setShowState:Dispatch<boolean>
}

function MobileOffCanvas({showState, setShowState}:MobileOffCanvasProps){
    const {logout} = useAuthData()

    return (
        <Offcanvas 
            show={showState} 
            onHide={() => setShowState(false)} 
            placement="bottom" 
            style={{height: "80vh"}} 
            className="bg-white"
        >
            <Offcanvas.Header closeButton className="border-bottom">
                <h5 className="mb-0 fw-bold">Menu</h5>
            </Offcanvas.Header>
            <Offcanvas.Body className="p-0">
                <div className="d-flex flex-column h-100">
                    <div className="flex-grow-1">
                        <Row className="w-100 m-0">
                            <Col className="w-100 p-0">
                                <Link 
                                    to="/" 
                                    className="d-flex align-items-center p-3 border-bottom text-decoration-none text-dark"
                                    onClick={() => setShowState(false)}
                                >
                                    <IoHomeOutline className="me-3" size={24}/>
                                    <span className="fs-5 fw-medium">Home</span>
                                </Link>
                            </Col>
                        </Row>
                        <Row className="w-100 m-0">
                            <Col className="w-100 p-0">
                                <Link 
                                    to="/connect-page" 
                                    className="d-flex align-items-center p-3 border-bottom text-decoration-none text-dark"
                                    onClick={() => setShowState(false)}
                                >
                                    <FiPower className="me-3" size={24}/>
                                    <span className="fs-5 fw-medium">Connect Page</span>
                                </Link>
                            </Col>
                        </Row>
                        <Row className="w-100 m-0">
                            <Col className="w-100 p-0">
                                <Link 
                                    to="/profile" 
                                    className="d-flex align-items-center p-3 border-bottom text-decoration-none text-dark"
                                    onClick={() => setShowState(false)}
                                >
                                    <IoPersonCircleSharp className="me-3" size={24}/>
                                    <span className="fs-5 fw-medium">Profile</span>
                                </Link>
                            </Col>
                        </Row>
                        <Row className="w-100 m-0">
                            <Col className="w-100 p-0">
                                <Link 
                                    to={import.meta.env.VITE_PUBLIC_STRIPE_CUSTOMER_PORTAL_LINK} 
                                    className="d-flex align-items-center p-3 border-bottom text-decoration-none text-dark"
                                    onClick={() => setShowState(false)}
                                >
                                    <FaMoneyCheck className="me-3" size={24}/>
                                    <span className="fs-5 fw-medium">Subscription</span>
                                </Link>
                            </Col>
                        </Row>
                        <Row className="w-100 m-0">
                            <Col className="w-100 p-0">
                                <Link 
                                    to="/links" 
                                    className="d-flex align-items-center p-3 border-bottom text-decoration-none text-dark"
                                    onClick={() => setShowState(false)}
                                >
                                    <IoIosLink className="me-3" size={24}/>
                                    <span className="fs-5 fw-medium">Links</span>
                                </Link>
                            </Col>
                        </Row>
                        <Row className="w-100 m-0">
                            <Col className="w-100 p-0">
                                <Link 
                                    to="/qr-codes" 
                                    className="d-flex align-items-center p-3 border-bottom text-decoration-none text-dark"
                                    onClick={() => setShowState(false)}
                                >
                                    <IoQrCodeOutline className="me-3" size={24}/>
                                    <span className="fs-5 fw-medium">QR Codes</span>
                                </Link>
                            </Col>
                        </Row>
                    </div>
                    <div className="mt-auto p-3 border-top">
                        <button 
                            className="w-100 btn btn-outline-danger py-3 fw-medium"
                            onClick={() => {
                                logout();
                                setShowState(false);
                            }}
                        >
                            Logout
                        </button>
                    </div>
                </div>
            </Offcanvas.Body>
        </Offcanvas>
    )
}

export default MobileOffCanvas